// extracted by mini-css-extract-plugin
export default {"root":"emptyData_root__s1+2B","image_inner":"emptyData_image_inner__CAIYz","title":"emptyData_title__LyFzP"};